import TooltipAndDetails from 'scoreboard/components/tooltip-and-details'
import config from 'scoreboard/components/config'
import guard from 'scoreboard/components/unsaved/guard'
import conductor from 'scoreboard/components/conductor'
import escapePreserveLineBreaks from 'scoreboard/components/escape-preserve-line-breaks'
import i18n from 'scoreboard/components/i18n'
import $ from 'jquery'

/**
 * Creates a link to a scorecard node that displays a tooltip
 *
 * @param el the root element
 * @param selector the selector to use for the attachment point
 * @param description
 * @param [id] the id of the metric. If not provided, the id will be taken from
 * the data-metric-id attribute
 * @return {Object} a handle to the backbone view
 */
export default function(el, selector, description, id) {
	return new TooltipAndDetails({
		el,
		selector,
		tooltipContent: function(e) {
			let html = ''
			if (config.displayIds) {
				let idToUse = this.getId(id, e)
				html += `<div>
						<span class="text-label">${i18n.get('common.id')}:</span>
						<span class="value">${idToUse}</span>
						<a class="view-details text-link" data-metric-id="${idToUse}">${idToUse}</a>
						</div>`
			}
			if (description) {
				html += `<div class="description"><span class="text-label">
							${i18n.get('common.description')}</span>:
							${escapePreserveLineBreaks(description)}</div>`
			}
			return html
		},
		details: function(e) {
			guard.conditionallyRun(() =>
				conductor.overview('scorecards', this.getId(id, e)))
		},
		tooltipOptions: {
			extraClass: 'metric-updates-id-tooltip'
		},
		/**
		 * Returns the given id if specified, or else reads the id from the
		 * data-metric-id attribute of the closest parent element
		 */
		getId: function(id, e) {
			return id ?? $(e.target)
				.closest('[data-metric-id]')
				.data('metric-id')
		}
	})
}